// extracted by mini-css-extract-plugin
export default {"CommentPart":"CommentList_CommentPart__zHskt","AnswerHolder":"CommentList_AnswerHolder__z7+hJ","TopDivisionComment":"CommentList_TopDivisionComment__SZa92"};